import styled from 'styled-components';

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 24px;
`